import React from 'react';

const UpdatePositionContext = React.createContext({
  update: () => {},
});

export const useUpdatePosition = () => {
  return React.useContext(UpdatePositionContext).update;
};

export const UpdatePositionProvider = ({ children, onUpdate }) => {
  return (
    <UpdatePositionContext.Provider value={{ update: onUpdate, onUpdate }}>
      {children}
    </UpdatePositionContext.Provider>
  );
};
